import './components/category-banner';
import SubCategory from './components/sub-category';

const categoryId = window.listingProducts[0].embedded_attributes.id_category_default;

document.addEventListener('DOMContentLoaded', async () => {
  const hasSubcategories = document.querySelectorAll('.sub-category-listing-boxes').length > 0;

  if (!hasSubcategories) {
    const refs = [];

    window.listingProducts?.forEach((product) => {
      if (product.reference) {
        refs.push(product.reference);
      }
    });

    let productStock = [];

    if (refs.length > 0) {
      try {
        productStock = await getStockData(refs);
      } catch (error) {
        console.error(error.message);
      }
    }

    // Initialize SubCategory with stock data
    new SubCategory({stockData: productStock});
  }
});

async function getStockData(refs) {
  const batchSize = 50;
  const batches = [];

  for (let i = 0; i < refs.length; i += batchSize) {
    console.log(`Fetching stock data for batch starting at index ${i}`);
    const batch = refs.slice(i, i + batchSize);
    const url = `https://shop.vital-parts.co.uk/products/check-stock?codes=${batch.join(',')}&pageid=${categoryId}`;
    batches.push(fetch(url).then((res) => {
      if (!res.ok) throw new Error(`Stock fetch error: ${res.status}`);
      return res.json();
    }));
  }

  const results = await Promise.all(batches);

  return results.flat(); 
}
